import { createFeatureSelector, createSelector } from '@ngrx/store';
import { commonIdVisitedPaperFeatureKey, State } from '../../reducers/common-id/common-id-visited-paper.reducer';

const selectCommonIdVisitedPaperState = createFeatureSelector<State>(commonIdVisitedPaperFeatureKey);

export const getCommonIdVisitedPapers = createSelector(selectCommonIdVisitedPaperState, state => state.visitedPaperIds);
